import { render, staticRenderFns } from "./phoneLink.vue?vue&type=template&id=99ec9270&scoped=true&lang=pug&"
import script from "./phoneLink.vue?vue&type=script&lang=ts&"
export * from "./phoneLink.vue?vue&type=script&lang=ts&"
import style0 from "./phoneLink.vue?vue&type=style&index=0&id=99ec9270&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ec9270",
  null
  
)

export default component.exports